/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2025-04-08 20:58:06 */

const Keys = {
  participants: 'participants',
  travelPeriod: 'travelPeriod',
  person: 'person',
  person_plural: 'person_plural',
  persons: 'persons',
  airportOfDeparture: 'airportOfDeparture',
  earliestTravelDate: 'earliestTravelDate',
  latestTravelDate: 'latestTravelDate',
  duration: 'duration'
}; export default Keys;